import { makeStyles } from "@material-ui/core";

export const MyAccountContainerStyles = makeStyles(theme => ({
  divider: { paddingLeft: "40px", paddingRight: "0px", paddingBottom: "70px" },
  infoContainer: {
    paddingLeft: "0px",
    paddingRight: "40px",
    paddingBottom: "70px",
    paddingTop: "30px",
    [theme.breakpoints.down("sm")]: {
      padding: "5px",
    },
  },
  emailWrap: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    textAlign: 'left',
  },
  saveButtonContainer: {
    paddingTop: 0,
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(2), // Adds top padding on small screens (mobile)
    },
  },
  titleContainer: {
    padding: "0px",
    paddingBottom: "30px",
    [theme.breakpoints.down("sm")]: {
      padding: "5px",
    },
    textAlign: "center",
  },
  titleText: {
    fontWeight: 700,
    fontSize: '30px',
  },
  user: {
    textAlign: "center",
  },
  amount: {
    textAlign: "center",
  },
  button: {
    marginRight: "12px",
  },
  orangeText: {
    color: theme.palette.primary.main,
  },
  greyText: {
    color: theme.palette.secondary.dark,
  },
  italicText: {
    fontStyle: "italic",
    color: theme.palette.secondary.dark,
  },
  accordionFlex: {
    flexDirection: "row",
    gap: "10px",
  },
  lastLoginText: {
    color: theme.palette.secondary.dark,
    fontWeight: 700,
    fontSize: '14px',
    marginBottom: '1rem'
  },
  pointer: {
    cursor: 'pointer'
  },
  searchOptionList: {
    zIndex: 999,
  },
  goFullScreen: {
    [theme.breakpoints.down('md')]: {
      minWidth: "100% !important",
      height: "100vh !important",
      maxHeight: "100vh !important",
      borderRadius: "0px !important",
    },
  },
}));
